import type { ReactNode } from 'react';
import { config } from '../../config';

export function AuthLayout({ title, children }: { title: string; children: ReactNode }) {
  return (
    <main className="flex min-h-screen items-center justify-center bg-slate-50 p-4">
      <div className="w-full max-w-sm rounded-lg border border-slate-200 bg-white p-6 shadow-sm">
        <p className="text-sm font-bold tracking-wide text-brand-700">{config.productName}</p>
        <h1 className="mt-2 text-xl font-bold">{title}</h1>
        <div className="mt-4">{children}</div>
      </div>
    </main>
  );
}
